module.exports = __webpack_public_path__ + "static/media/fsyuce024.e2a0bcc1.jpg";